import { useContext, useMemo } from "react";
import { PermissionsCtx } from "./PermissionsProvider";
import { AuthContext } from "../AuthProvider";
import { canFromGrants } from "./can";
import { usePermissionScopes } from "./PermissionScope";
import { useSupportViewAs } from "../supportViewAs/SupportViewAsProvider";

export function useCan(resource, action = "view") {
  const { ready, grants } = useContext(PermissionsCtx);
  const { keycloak } = useContext(AuthContext);
  const supportViewAs = useSupportViewAs();
  const scopes = usePermissionScopes();
  const tokenParsed = supportViewAs?.active ? null : keycloak?.tokenParsed;

  return useMemo(() => {
    return canFromGrants({ ready, grants, tokenParsed, resource, action, scopes });
  }, [ready, grants, resource, action, tokenParsed, scopes]);
}
